import { restClient } from '../client';

export type NextAssessmentOutput = { status: 'not_found' }
| { status: 'found'; submission_id: string };

export const getNextAssessment = (_params: null) => restClient.request<NextAssessmentOutput>('/api/v1/form/next_form', {
  method: 'GET',
});
